@import (reference) 'ui-components/components/text/text.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.other-shipping-options-section {
  color: var(--default--text-color--18);
}

.content {
  padding: @space-0 @space-16 @space-16;
}

.form {
  margin: @space-0;
  display: flex;
  flex-flow: column nowrap;
  gap: @space-16;
}

.option-section {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-8;

  > div {
    margin: @space-0;
  }

  // Checkbox label
  label {
    .paragraph();
  }
}

.section-title {
  color: var(--default--text-color--18);
}

.bill-to-row {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: stretch;
  gap: @space-8;

  &:not(:first-child) {
    margin-top: @space-0;
  }

  > div {
    flex: 1;
  }

  label {
    flex: 1;
    padding: @space-0;
    text-align: start;
    min-width: auto;
    .section-title();
  }
}

.bill-to-dropdown {
  width: 100%;
}

.read-only-row {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-4;
  padding: @space-0;
}

.read-only-value-section {
  color: var(--default--text-color--16);

  gap: @space-4;
}
